import { createContext } from 'react';

/**
 * Provides the id of the Custom Homepage content module a content card is
 * rendered within. Consumed at the `w:ContentCard:click` site
 * (`solar-feed-card`) to tag clicks with `custom_homepage_module_id` (FE-32869)
 * so Intelligence can map the module id to its name in reporting.
 *
 * Defaults to `undefined` — off the custom homepage (topic/channel feeds, the
 * "see all" module page, etc.) no provider is present, so the property is
 * omitted from the event.
 */
export const CustomHomepageModuleContext = createContext<string | undefined>(
  undefined
);
